import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import {
  MAXIMUM_FILE_UPLOAD_SIZE,
  MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL,
} from 'shared/constants/messages';
import { checkFileSizeLimit } from 'shared/helpers/FileHelper';
import { DirectUpload } from 'activestorage';
import { getUBAttachmentUploadResult } from '../helper/fileProcessor';
import getUuid from 'widget/helpers/uuid';
import { reportFileUploadEvent } from '../helper/fileUploadEvents';

export default {
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentChat: 'getSelectedChat',
      inboxGetter: 'inboxes/getInboxById',
    }),
    inbox() {
      return this.inboxGetter(this.currentChat.inbox_id);
    },
  },
  methods: {
    onFileUpload(file) {
      if (this.globalConfig.directUploadsEnabled) {
        this.onDirectFileUpload(file);
      } else {
        this.onIndirectFileUpload(file);
      }
    },
    onDirectFileUpload(file) {
      const MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE = this.isATwilioSMSChannel
        ? MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL
        : MAXIMUM_FILE_UPLOAD_SIZE;

      if (!file) {
        return;
      }
      if (checkFileSizeLimit(file, MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE)) {
        const upload = new DirectUpload(
          file.file,
          `/api/v1/accounts/${this.accountId}/conversations/${this.currentChat.id}/direct_uploads`,
          {
            directUploadWillCreateBlobWithXHR: xhr => {
              xhr.setRequestHeader(
                'api_access_token',
                this.currentUser.access_token
              );
            },
          }
        );

        upload.create((error, blob) => {
          if (error) {
            useAlert(error);
          } else {
            this.attachFile({ file, blob });
          }
        });
      } else {
        useAlert(
          this.$t('CONVERSATION.FILE_SIZE_LIMIT', {
            MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE,
          })
        );
      }
    },
    async onIndirectFileUpload(file) {
      reportFileUploadEvent('startFileUpload', '');
      const MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE = this.isATwilioSMSChannel
        ? MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL
        : MAXIMUM_FILE_UPLOAD_SIZE;
      if (!file) {
        reportFileUploadEvent('checkFileExist', 'file is null');
        return;
      }
      if (checkFileSizeLimit(file, MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE)) {
        reportFileUploadEvent('checkFileSizeLimitSuccess', '');
        // 如果开关未开启，走原上传逻辑
        if (!this.inbox.ub_enable_attachments_upload) {
          reportFileUploadEvent('checknableUBAttachmentUpload', 'inbox.ub_enable_attachments_upload is false');
          this.attachFile({ file, params: { isLoading: false, ubUploaded: false } });
          return;
        }
        // 如果文件类型不支持，直接return
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
        const isPdf = file.type.startsWith('application/pdf');
        if (!isImage && !isVideo && !isPdf) {
          reportFileUploadEvent('checkFileTypes', 'file types is not image or video');
          useAlert("Unsupported file types, please upload pictures or videos")
          // this.attachFile({ file, params: { isLoading: false, ubUploaded: false } });
          return;
        }
        const uuid = getUuid();
        this.attachFile({ file, ubAttachment: null, params: { isLoading: true, uuid } });
        reportFileUploadEvent('startUBAttachmentUpload', '');
        const { success, ubAttachment } = await getUBAttachmentUploadResult(file.file);
        if (success) {
          reportFileUploadEvent('UBAttachmentUploadSuccess', '');
          // 如果文件上传成功，则更新文件状态
          this.attachFile({ file, ubAttachment, params: { isLoading: false, ubUploaded: true, uuid } });
        } else {
          reportFileUploadEvent('UBAttachmentUploadFailed', '');
          // 如果文件上传失败，则删除文件
          this.deleteAttachment({ file, ubAttachment, uuid });
        }
      } else {
        reportFileUploadEvent('checkFileSizeLimitFailed', 'file size out of limit');
        useAlert(
          this.$t('CONVERSATION.FILE_SIZE_LIMIT', {
            MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE,
          })
        );
      }
    },
  },
};
